import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import * as services from 'modules/appointmentsManagement/services/fetchServiceProviders';

import createAction from './';

export const FETCH_APPOINTMENT_SERVICE_PROVIDERS = createAsyncAction(createAction('FETCH_APPOINTMENT_SERVICE_PROVIDERS'));

export const fetchAppointmentServiceProviders = (selectedService) => (dispatch, getState) => {
  dispatch({ type: FETCH_APPOINTMENT_SERVICE_PROVIDERS.pending });

  const state = getState();
  const { serviceId } = selectedService || state.appointmentInfo.currentAppointment.service;

  const sort = {
    field: 'USER_FULLNAME',
    direction: 'ASC',
  };

  const apiCallParams = {
    query: services.FETCH_APPOINTMENT_SERVICE_PROVIDERS,
    variables: {
      serviceId,
      sort,
    },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {
      const {
        data: {
          getProvidersWithServiceAvailability: {
            providers,
            isProviderGroupAvailable,
            providerGroupSpecialties,
          },

        },
      } = response;

      return dispatch({
        type: FETCH_APPOINTMENT_SERVICE_PROVIDERS.success,
        payload: {
          providers: { providers, isProviderGroupAvailable },
          providerGroupSpecialties: providerGroupSpecialties || [],
        },
      });

    })
    .catch((err) => {
      dispatch(errorAction(FETCH_APPOINTMENT_SERVICE_PROVIDERS.failure, err));
      throw err;
    });
};
